module.exports = __webpack_public_path__ + "static/media/ScrumBoard.b864b598.png";